
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import InstrumentList from "@/components/InstrumentList.vue";
    import {auditApi} from "@/api/audit";
    import reasons from "@/components/Reasons.vue";
    import html2Canvas from "html2canvas";
    import JsPDF from "jspdf";
    import {checkTypeList} from "@/js/checkType";

    @Component({
        name: "adminOrganDetail",
        components: {InstrumentList,reasons}
    })
    export default class Home extends Vue {
        title = "器具备案";
        id = "0";   //id
        pageType = "0";  //0编辑  1查看
        listData = [];  //详情返回数据
        private closePage: any;
        private exportReport: any;
        failDialog = false;  //拒收原因
        allSelected = [];

        created() {
            this.init();
        }
        init(){
            this.id = this.$route.params.id;
            this.pageType = this.$route.params.type;
            this.getDetail();
        }
        //获取器具详情
        getDetail(){
          this.tableClearSelect();
            auditApi.getOrderDetail({orderId:this.id}).then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    rData.result0Arr = rData.instrumentDtos.filter((e: any) => {
                        return e.result.value == 0;
                    });
                    if(this.pageType == "0" && rData.result0Arr.length == 0){
                        //全部办理完成
                        this.$message.success("全部办理完成");
                        this.closePage();
                    }
                    this.listData = rData;
                }
            })
        }
        tableClearSelect(){
          this.allSelected = [];
          let $table = this.$refs.table as HTMLFormElement;
          if($table){
            $table.clearSelection();
          }
        }
        failBtn(){
            const dataArr = this.allSelected;
            if(dataArr.length == 0){
                this.$message.error("请先勾选器具");
                return;
            }
            this.failDialog = true;
        }
        orderNotPassBtn(){
          let reasons = this.$refs.reasons as HTMLFormElement;
          const reason = reasons.getText();
          if (reason == "") {
            this.$message.error("拒收原因必填");
            return
          }
          const instrIds = this.allSelected.flatMap((s: any) => s.id);
          const params = {
            orderId: this.id,
            instrIds: instrIds,
            reason: reason
          }
          auditApi.orderNotPass(params).then(r => {
            this.failDialog = false;
            this.$message.success("设置成功");
            this.getDetail();
          });
        }
        //获取勾选  result 2 拒收  1接收
        checkOrder(result: number){
            const idArr = this.allSelected.flatMap((e: any) => e.id);
            if(idArr.length == 0){
                this.$message.error("请先勾选器具");
                return;
            }
            const params = {
                instrumentIds: idArr.join(","),
                orderId: this.id,
                result: result
            }
            auditApi.checkOrder(params).then(r => {
                this.$message.success("设置成功");
                this.getDetail();
            })
        }

        showCheckTypeStr(e:any){
            let str = "";
            const obj = checkTypeList.find((e2: any)=>e2.id == e.checkType);
            if(obj){
                str = obj.name;
            }else {
                str = '-';
            }
            return str;
        }
        instrDetail(data: any) {
            let id = data.id;
            this.$router.push("/qj/instrument/detail/2/" + id);
        }

        memberSelectAll(selections: any){
            this.memberSelect(selections);
        }
        memberSelect(selections: any) {
            this.allSelected = selections;
        }

        downFile() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
                const pdfDom = this.$refs.pdfDom as HTMLFormElement;
                this.exportReport(pdfDom, "计量器具备案申请表", () => {
                    loading.close();
                });
            }, 1000);
        }
    }
